module.exports = __webpack_public_path__ + "static/media/173.680ec8f8.wav";